<template>
  <el-dialog :visible.sync="isShow" class="contact-wrap" width="500px">
    <p>提交邮件后，专属客户经理会尽快与您联系</p>
    <p>邮箱：apihezuo@xiaozhu.com</p>
    <!-- <el-form :model="form">
      <el-form-item label="公司名称" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="联系人" :label-width="formLabelWidth">
        <el-input v-model="form.person" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" :label-width="formLabelWidth">
        <el-input v-model="form.tele" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>-->
    <div slot="footer" class="dialog-footer">
      <a @click="isShow = false" class="btn">我知道了</a>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      formLabelWidth: "142px",
      form: {
        name: "",
        person: "",
        tele: ""
      },
      isShow: false
    };
  },
  props: {
    showDialog: {
      default: false,
      type: Boolean
    }
  },
  watch: {
    showDialog(newVal) {
      this.isShow = newVal;
    },
    isShow(newVal) {
      this.$emit("update:show-dialog", newVal);
    }
  },
  methods: {}
};
</script>
<style lang="scss">
.contact-wrap {
  .el-dialog__body {
    padding: 25px 70px 28px 70px;
    .el-form-item__label {
      color: #757575;
      font-size: 28px;
      padding: 0 30px 0 0;
    }
  }
  .el-dialog__footer {
    text-align: center;
    padding: 0 0 40px 0;
  }
  .el-input__inner {
    border: 1px solid #e0e0e0;
    font-size: 20px;
    color: #212121;
  }
}
</style>
<style lang="scss" scoped>
.contact-wrap {
  .tips {
    color: #212121;
    font-size: 28px;
    letter-spacing: 0.05px;
    font-weight: bold;
    text-align: center;
    margin: -26px 0 40px 0;
  }
  p {
    font-size: 18px;
  }
  .btn {
    display: inline-block;
    width: 160px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    font-size: 20px;
    color: #fff;
    background-color: #00269a;
    border-radius: 4px;
    font-family: PingFangSC-Semibold;
  }
}
</style>
